"use strict";

export var number_DS = [{
  id: 2,
  text: 'Equals',
  icon: 'dx-icon dx-icon-equal',
  operation: 'equal',
  symbol: '=',
  items: []
}, {
  id: 3,
  text: 'Does not equal',
  icon: 'dx-icon dx-icon-notequal',
  operation: 'notequal',
  symbol: '<>',
  items: []
}, {
  id: 4,
  text: 'Less than',
  icon: 'dx-icon dx-icon-less',
  operation: 'less',
  symbol: '<',
  items: []
}, {
  id: 5,
  text: 'Greater than',
  icon: 'dx-icon dx-icon-greater',
  operation: 'greater',
  symbol: '>',
  items: []
}, {
  id: 6,
  text: 'Less than or equal to',
  icon: 'dx-icon dx-icon-lessorequal',
  operation: 'lessorequal',
  symbol: '<=',
  items: []
}, {
  id: 7,
  text: 'Greater than or equal to',
  icon: 'dx-icon dx-icon-greaterorequal',
  operation: 'greaterorequal',
  symbol: '>=',
  items: []
}, {
  id: 8,
  text: 'Between',
  icon: 'dx-icon dx-icon-range',
  operation: 'range',
  symbol: 'between',
  items: []
}, {
  id: 9,
  text: 'Is blank',
  icon: 'dx-icon fontawesome far fa-file',
  operation: 'isblank',
  symbol: 'isblank',
  items: []
}, {
  id: 10,
  text: 'Is not blank',
  icon: 'dx-icon fontawesome fas fa-file-alt',
  operation: 'isnotblank',
  symbol: 'isnotblank',
  items: []
}, {
  id: 11,
  text: 'Is any of',
  icon: 'dx-icon fontawesome far fa-list-alt',
  operation: 'isanyof',
  symbol: 'isanyof',
  items: []
}, {
  id: 12,
  text: 'Is not any of',
  icon: 'dx-icon fontawesome fas fa-list-alt',
  operation: 'isnotanyof',
  symbol: 'isnotanyof',
  items: []
}];
export var date_DS = [{
  id: 2,
  text: 'Equals',
  icon: 'dx-icon dx-icon-equal',
  operation: 'equal',
  symbol: '=',
  items: []
}, {
  id: 3,
  text: 'Does not equal',
  icon: 'dx-icon dx-icon-notequal',
  operation: 'notequal',
  symbol: '<>',
  items: []
}, {
  id: 4,
  text: 'Less than',
  icon: 'dx-icon dx-icon-less',
  operation: 'less',
  symbol: '<',
  items: []
}, {
  id: 5,
  text: 'Greater than',
  icon: 'dx-icon dx-icon-greater',
  operation: 'greater',
  symbol: '>',
  items: []
}, {
  id: 6,
  text: 'Less than or equal to',
  icon: 'dx-icon dx-icon-lessorequal',
  operation: 'lessorequal',
  symbol: '<=',
  items: []
}, {
  id: 7,
  text: 'Greater than or equal to',
  icon: 'dx-icon dx-icon-greaterorequal',
  operation: 'greaterorequal',
  symbol: '>=',
  items: []
}, {
  id: 8,
  text: 'Between',
  icon: 'dx-icon dx-icon-range',
  operation: 'range',
  symbol: 'between',
  items: []
}, {
  id: 9,
  text: 'Is blank',
  icon: 'dx-icon fontawesome far fa-file',
  operation: 'isblank',
  symbol: 'isblank',
  items: []
}, {
  id: 10,
  text: 'Is not blank',
  icon: 'dx-icon fontawesome fas fa-file-alt',
  operation: 'isnotblank',
  symbol: 'isnotblank',
  items: [] // ,{
  //     id: 11,
  //     text: 'Is any of',
  //     icon: 'dx-icon fontawesome far fa-list-alt',
  //     operation: 'isanyof',
  //     symbol: 'isanyof',
  //     items: []
  // },{
  //     id: 12,
  //     text: 'Is not any of',
  //     icon: 'dx-icon fontawesome fas fa-list-alt',
  //     operation: 'isnotanyof',
  //     symbol: 'isnotanyof',
  //     items: []
  // }

}];
export var string_DS = [{
  id: 2,
  text: 'Contains',
  icon: 'dx-icon dx-icon-contains',
  operation: 'contains',
  symbol: 'contains',
  items: []
}, {
  id: 3,
  text: 'Equals',
  icon: 'dx-icon dx-icon-equal',
  operation: 'equal',
  symbol: '=',
  items: []
}, {
  id: 4,
  text: 'Does not equal',
  icon: 'dx-icon dx-icon-notequal',
  operation: 'notequal',
  symbol: '<>',
  items: []
}, {
  id: 5,
  text: 'Is blank',
  icon: 'dx-icon fontawesome far fa-file',
  operation: 'isblank',
  symbol: 'isblank',
  items: []
}, {
  id: 6,
  text: 'Is not blank',
  icon: 'dx-icon fontawesome fas fa-file-alt',
  operation: 'isnotblank',
  symbol: 'isnotblank',
  items: []
}, {
  id: 7,
  text: 'Is any of',
  icon: 'dx-icon fontawesome far fa-list-alt',
  operation: 'isanyof',
  symbol: 'isanyof',
  items: []
}, {
  id: 8,
  text: 'Is not any of',
  icon: 'dx-icon fontawesome fas fa-list-alt',
  operation: 'isnotanyof',
  symbol: 'isnotanyof',
  items: []
}];